import md5 from "crypto-js/md5";
import sha256 from "crypto-js/sha256";

function removeForbiddenChars(str: string) {
  return str
    .replace(/[^a-zA-Z0-9.| ]+/g, " ") // replace forbidden characters with spaces
    .replace(/  +/g, " ") // remove multiple spaces
    .trim();
}

function formatNumbers(str: string) {
  return str
    .replace(/[',](\d{3})/g, "$1") // removes thousands separators (' and ,)
    .replace(/(\d{1,3}),/g, "$1."); // replaces comma digit separator with dot
}

export function formatText(str: string | null) {
  if (!str) return str;
  return removeForbiddenChars(formatNumbers(str ?? ""));
}

export function getHashedString(str: string) {
  return {
    md5: md5(str).toString(),
    sha256: sha256(str).toString(),
  };
}

export enum GoogleAnalyticsEvent {
  Login = "login",
  Logout = "logout",
  ViewPersonalAreaProfile = "view_personal_profile",
  UpdatePersonalAreaProfile = "update_personal_profile",
  ClickProduct = "click_product",
  Filter = "filter",
  ClickLocation = "click_location",
  CustomerStoryView = "customer_story_view",
  ViewJobList = "view_job_list",
  ViewJobPosition = "view_job_position",
  ViewExhibitionInfo = "view_exhibition_info",
  ProductView = "product_view",
  NewsView = "news_view",
  BuyExhibitionTicketCta = "buy_exhibition_ticket_cta",
  DownloadCatalogue = "download_catalogue",
  ViewEventInfo = "view_event_info",
  EventAccreditationCta = "event_accreditation_cta",
  ViewEventsList = "view_events_list",
  ViewExhibitionsList = "view_exhibitions_list",
  FileDownload = "file_download",
  ClickFooter = "click_footer",
  OpenForm = "open_form",
  FormSubmit = "form_submit",
  FormError = "form_error",
  JobApplication = "job_application",
  ShareJobPosition = "share_job_position",
  ViewProductList = "view_product_list",
  ProductCompare2 = "product_compare_2",
  ProductCompare3 = "product_compare_3",
  Locator = "locator",
  DlStart = "dl_start",
  Search = "search",
  Newsletter = "newsletter",
  Request = "request",
  Facebook = "facebook",
  Instagram = "instagram",
  Linkedin = "linkedin",
  Youtube = "youtube",
}

export enum LoginStatus {
  Logged = "logged",
  NotLogged = "not logged",
}

export enum NonEditorialPagesBreadcrumbs {
  PersonalArea = "personal-area",
  Profile = "profile",
  Calendar = "calendar",
  Search = "search",
}

export enum SearchResults {
  Results = "results",
  NoResults = "no results",
}

export enum FilterContentGroup {
  ProductList = "ProductList",
  EventList = "EventList",
  ExhibitionList = "ExhibitionList",
  JobList = "JobList",
}
